import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IDataGrid } from './../models/data-grid.model';
@Injectable({
  providedIn: 'root'
})
export class FormTemplateGridService {

  constructor(private http: HttpClient) {
  }

  async getFormTemplateAsync(formTemplateName) {
    var template = await this.http.get<IDataGrid>("assets/formtemplates/" + formTemplateName + ".json").toPromise();
    return template;
  }

  getFormTemplate(formTemplateName) {
    var template = this.http.get<IDataGrid>("assets/formtemplates/" + formTemplateName + ".json");
    return template;
  }
}